// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { ModuleDriver } from '../_contracts';
import { getModuleBase } from '../_helpers/adapter';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export class BlockquoteAdapter {
    /**
     * Adapts (translates/maps) the passed-in `BlockquoteModule` to the `BlockquoteToken`.
     *
     * @param object - The module to adapt.
     */
    objectToToken(object) {
        const { content } = object;
        // Check the `content` property.
        if (typeof content !== 'object') {
            throw new Error(`BlockquoteAdapter.objectToToken(): [object.content] property should be an [object], but got ${typeof content}!\nFull [object] object: ${JSON.stringify(object)}`);
        }
        const { author, text } = content;
        // Check the `content.author` property.
        if (typeof author !== 'undefined' && typeof content.author !== 'string') {
            throw new Error(`BlockquoteAdapter.objectToToken(): [object.content.author] property should be a [string], but got ${typeof author}!\nFull [object] object: ${JSON.stringify(object)}`);
        }
        // Check the `content.text` property.
        if (typeof text !== 'string') {
            throw new Error(`BlockquoteAdapter.objectToToken(): [object.content.text] property should be a [string], but got ${typeof text}!\nFull [object] object: ${JSON.stringify(object)}`);
        }
        // Construct the `raw` property.
        let raw = `> ${text}`;
        if (typeof author === 'string') {
            raw = `${raw} @ ${author}`;
        }
        // Prepare the `token` object.
        const token = {
            content: text,
            raw,
            type: TokenType.Blockquote
        };
        // Define the token's meta, if the author has been specified.
        if (typeof author === 'string') {
            token.meta = {
                author: author
            };
        }
        // Return the constructed token.
        return token;
    }
    /**
     * Adapts (translates/maps) the passed-in `BlockquoteToken` to the `BlockquoteModule`.
     *
     * @param token - The token to adapt.
     */
    tokenToObject(token) {
        const { content: _content, meta } = token;
        if (typeof _content !== 'string') {
            throw new Error(`BlockquoteAdapter.tokenToObject(): [token.content] property should be a [string], but got ${typeof _content}!\nFull [token] object: ${JSON.stringify(token)}`);
        }
        if (typeof meta !== 'undefined' && typeof meta.author !== 'string') {
            throw new Error(`BlockquoteAdapter.tokenToObject(): [token.meta.author] property should be a [string], but got ${typeof meta.author}!\nFull [token] object: ${JSON.stringify(token)}`);
        }
        // Prepare the `content` object.
        const content = {
            text: _content
        };
        // Define the `author` property, if the author has been specified.
        if (typeof meta !== 'undefined' && typeof meta.author === 'string') {
            content.author = meta.author;
        }
        return {
            ...getModuleBase(),
            content,
            driver: ModuleDriver.Blockquote
        };
    }
}
